import React from 'react';
import { useInView } from 'react-intersection-observer';
import BeforeAfter from './BeforeAfter';
import choyen from '../assets/images/5000choyen.png';

export default function Hero() {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <div className="pt-32 pb-20 bg-gradient-to-br from-primary-500/5 via-accent-500/5 to-secondary-500/5 relative overflow-hidden">
      <div className="absolute inset-0 bg-[url('/grid.svg')] opacity-10"></div>
      <div className="absolute w-[500px] h-[500px] bg-primary-500/30 rounded-full blur-3xl -top-48 -left-48"></div>
      <div className="absolute w-[500px] h-[500px] bg-accent-500/20 rounded-full blur-3xl -bottom-48 -right-48"></div>
      <div className="container mx-auto px-6 relative">
        <div className="max-w-4xl mx-auto text-center space-y-8" ref={ref}>
          <div className={`space-y-6 transition-all duration-700 ${
            inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}>
            <div className="flex justify-center">
              <img 
                src={choyen} 
                alt="5000兆円欲しい！" 
                className="w-[200px] md:w-[280px] h-auto"
              />
            </div>
          
            <h1 className="text-4xl md:text-6xl font-bold inline-block relative">
              <span>
                <span className="bg-gradient-to-r from-primary-600 via-accent-500 to-secondary-500 animate-gradient bg-[length:200%_auto] bg-clip-text text-transparent leading-relaxed">
                  ユーザーを増やす<br className="leading-[2]"/>AIショート動画生成
                </span>
              </span>
            </h1>
            <div className="flex flex-col gap-4 max-w-2xl mx-auto">
              <div className="flex justify-end">
                <div className="backdrop-blur-xl bg-white/10 rounded-2xl rounded-tr-sm border border-white/20 shadow-[0_8px_32px_0_rgba(31,38,135,0.1)] p-4 max-w-[80%] backdrop-saturate-200">
                  <p className="text-base md:text-lg text-gray-600 text-left">
                    とりあえずサービスを作ったけどユーザーが来ない...😭
                  </p>
                </div>
              </div>
              <div className="flex justify-start">
                <div className="bg-[#C5E9B4] rounded-2xl rounded-tl-sm p-4 max-w-[80%] shadow-md">
                  <p className="text-base md:text-lg text-black font-medium text-left">
                    Shortmakerならコスパ最大でユーザーを獲得できるよ 🔥
                  </p>
                </div>
              </div>
            </div>
          </div>

         <div className={`transition-all duration-700 delay-300 ${
            inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}>
            <BeforeAfter />
          </div>

          <div className="space-y-4">
            <p className={`text-xl text-primary-600/90 transition-all duration-700 delay-200 font-bold ${
              inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
            }`}>
              \少数限定でβ版ユーザー募集中 🔥/
            </p>
            
            <div className={`flex flex-col sm:flex-row justify-center gap-4 transition-all duration-700 delay-400 ${
              inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
            }`}>
              <button className="group relative px-12 py-6 rounded-full text-xl font-medium overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300">
                <div className="absolute inset-0 bg-gradient-to-r from-primary-600 to-accent-500 transition-all duration-300 group-hover:scale-[1.02] group-hover:brightness-110"></div>
                <div className="absolute inset-0 opacity-0 group-hover:opacity-20 bg-white transition-opacity duration-300"></div>
                <div className="relative flex items-center justify-center gap-2 text-white transition-transform duration-300 group-hover:scale-[1.02]">
                  <span className="font-bold group-hover:tracking-wide transition-all duration-300">β版を試してみる</span>
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
